/* Artapli shop style book (approved by Anna 2026-10-22), behaviour part.
   - Top menu, Shop: the six groups as columns under their circles, with counts and
     sub-categories on a thin pink line (Anna chose "everything in columns").
   - Top menu, Apps: tool characters in the app cards and quick tool tiles.
   Reads the same nightly menu contract the menu itself uses; changes nothing when the
   menu is not on the page. Source: StudioAssistant/theme/style-book-20261022/. */
(() => {
  const CHARACTERS = {
    'lettering-v3': { src: 'https://artapli.shop/cdn/shop/files/lettering_483ea2bb-4a1b-40d9-b41e-5bcb38dec8a8.png?v=1792664127&width=220' },
    'mockup': { src: 'https://cdn.shopify.com/s/files/1/0924/8138/8918/files/Collaborative_Pink_Embroidery_Design_a504be57-8584-4e5d-a225-fe9e78aae37c.png?v=1792698630&width=220', fit: true },
    'embroidery-previewer-app': { src: 'https://artapli.shop/cdn/shop/files/PREVIEW_90e9b2ac-61ab-4a26-b49f-b2a4e7959d6f.png?v=1792664127&width=160' },
    'app-embroidery-analyzer': { src: 'https://artapli.shop/cdn/shop/files/ZIP_0b57b83e-ea49-46bb-ace7-877b14e8e068.png?v=1792664127&width=160' },
    'dst-optimizer': { src: 'https://artapli.shop/cdn/shop/files/DST_3c0a3cc4-e878-4b83-9e4b-49c5d63506b4.png?v=1792664127&width=160' },
    'print-my-design-at-100-scale': { src: 'https://artapli.shop/cdn/shop/files/Print_51aee5cb-c33f-4643-b7cc-8dab473198b5.png?v=1792664127&width=160' },
    'svg-creator': { src: 'https://artapli.shop/cdn/shop/files/SVG_8767226e-d3c4-4769-bd97-389138547b87.png?v=1792664127&width=160' },
    'thread-color-picker': { src: 'https://cdn.shopify.com/s/files/1/0924/8138/8918/files/thread-color-picker-card-v3.jpg?v=1793004371&width=160' },
    'library': { src: 'https://cdn.shopify.com/s/files/1/0924/8138/8918/files/Pink_Embroidery_Studio_Glow.png?v=1792701874&width=220', fit: true },
  };
  // Small line icons before the titles, so similar characters stay easy to tell apart (Anna 2026-10-22).
  const TITLE_ICONS = {
    'library': '<path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/>',
    'lettering-v3': '<path d="m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284"/><path d="M3 21h18"/>',
    'mockup': '<rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
    'embroidery-previewer-app': '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5"/>',
    'app-embroidery-analyzer': '<path d="M3 6h7l2 2h9v11H3V6Z"/>',
    'dst-optimizer': '<path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z"/>',
    'print-my-design-at-100-scale': '<path d="M6 9V3h12v6M6 18H4V10h16v8h-2M7 15h10v6H7v-6Z"/>',
    'svg-creator': '<circle cx="7" cy="7" r="3"/><rect x="13" y="4" width="7" height="7"/><path d="m4 20 4-7 4 7H4Z"/>',
    'thread-color-picker': '<path d="M3 4h9M3 20h9M4.5 4v16M10.5 4v16"/><path d="m4.5 9.5 6-2.5M4.5 14l6-2.5M4.5 18.5l6-2.5"/><circle cx="17.5" cy="6" r="2.4"/><circle cx="17.5" cy="12" r="2.4"/><circle cx="17.5" cy="18" r="2.4"/>',
  };
  const titleIcon = key => TITLE_ICONS[key] ? '<svg class="sb-ti" viewBox="0 0 24 24" aria-hidden="true">' + TITLE_ICONS[key] + '</svg>' : '';
  const addTitleIcon = (el, key) => { if (el && !el.querySelector('.sb-ti') && TITLE_ICONS[key]) el.insertAdjacentHTML('afterbegin', titleIcon(key)); };
  const root = document.getElementById('artapli-menu-v2');
  if (!root) return;

  const prefix = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  const loc = href => (href && href.startsWith('/') && prefix && !href.startsWith(prefix + '/')) ? prefix + href : (href || '#');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const visible = n => (n.children || []).filter(k => k.visibility !== 'hidden');
  const count = n => n.taxonomy_projection && Number.isInteger(n.taxonomy_projection.distinct_sku_count) ? n.taxonomy_projection.distinct_sku_count.toLocaleString('en-US') : '';
  const thumb = url => url ? url + (url.includes('?') ? '&' : '?') + 'width=160' : '';
  const firstHref = n => n.href || (visible(n)[0] && firstHref(visible(n)[0])) || '#';

  function characters() {
    const pic = (c, alt) => '<span class="sb-pic"><img src="' + c.src + '" alt="' + esc(alt) + '" loading="lazy"' + (c.fit ? ' class="sb-fit"' : '') + '></span>';
    root.querySelectorAll('.app-card').forEach(card => {
      if (card.querySelector('.sb-pic')) return;
      const key = Object.keys(CHARACTERS).find(k => decodeURIComponent(card.getAttribute('href') || '').includes('/' + k));
      const icon = card.querySelector('.brand-icon');
      if (key && icon) { icon.outerHTML = pic(CHARACTERS[key], ''); addTitleIcon(card.querySelector('h3'), key); }
    });
    root.querySelectorAll('.mobile-menu-v4 .mobile-feature, .mobile-menu-v4 .mobile-circle-link').forEach(a => {
      if (a.querySelector('.sb-pic')) return;
      const href = decodeURIComponent(a.getAttribute('href') || '');
      const key = Object.keys(CHARACTERS).find(k => href.includes('/' + k));
      const slot = a.querySelector('.mobile-feature-icon, .mobile-circle-art');
      if (key && slot) { slot.innerHTML = pic(CHARACTERS[key], ''); addTitleIcon(a.querySelector('.mobile-feature-label strong, .mobile-circle-link > span:last-child'), key); }
    });
    root.querySelectorAll('.tool').forEach(tool => {
      if (tool.querySelector('.sb-pic')) return;
      const key = Object.keys(CHARACTERS).find(k => (tool.getAttribute('href') || '').includes('/' + k));
      const icon = tool.querySelector('.tool-icon');
      if (key && icon) { icon.outerHTML = pic(CHARACTERS[key], ''); addTitleIcon(tool.querySelector('strong'), key); }
    });
  }

  function columns(menu, shop) {
    if (shop.querySelector('.sb-shop-cols')) return;
    const groups = (menu.product_tree || []).filter(n => n.visibility !== 'hidden');
    if (!groups.length) return;
    const link = (n, cls) => '<a class="sb-link' + (cls ? ' ' + cls : '') + '" href="' + esc(loc(n.href || firstHref(n))) + '"><span>' + esc(n.label) + '</span><span class="sb-c">' + count(n) + '</span></a>';
    const html = groups.map(g => {
      const kids = visible(g);
      const items = kids.map(k => {
        const sub = visible(k);
        return link(k) + (sub.length ? '<div class="sb-sub">' + sub.map(s => link(s)).join('') + '</div>' : '');
      });
      const shown = items.slice(0, 8).join('');
      const rest = items.slice(8).map(i => '<div class="sb-rest" hidden>' + i + '</div>').join('');
      const more = items.length > 8 ? '<button class="sb-more" type="button">+' + (items.length - 8) + ' more</button>' : '';
      return '<div class="sb-col"><a class="sb-head" href="' + esc(loc(firstHref(g))) + '"><span class="sb-ring">' + (g.image ? '<img src="' + esc(thumb(g.image)) + '" alt="" loading="lazy">' : '') + '</span><b>' + esc(g.label) + '</b><small>' + kids.length + ' ' + (kids.length === 1 ? 'category' : 'categories') + '</small></a>' + shown + rest + more + '</div>';
    }).join('');
    const box = document.createElement('div');
    box.className = 'sb-shop-cols';
    box.innerHTML = html;
    box.addEventListener('click', e => {
      const b = e.target.closest('.sb-more');
      if (!b) return;
      b.parentElement.querySelectorAll('.sb-rest').forEach(r => { r.hidden = false; });
      b.remove();
    });
    const tabs = shop.querySelector('.taxonomy-tabs');
    tabs.parentNode.insertBefore(box, tabs);
    shop.classList.add('sb-done');
  }


  function phoneGroups(menu, hub) {
    if (hub.querySelector('.sb-m-groups')) return;
    const groups = (menu.product_tree || []).filter(n => n.visibility !== 'hidden');
    if (!groups.length) return;
    const link = (n, sub) => '<a class="sb-m-link' + (sub ? ' sb-m-sublink' : '') + '" href="' + esc(loc(n.href || firstHref(n))) + '"><span>' + esc(n.label) + '</span><span class="sb-c">' + count(n) + '</span></a>';
    const box = document.createElement('div');
    box.className = 'sb-m-groups';
    box.innerHTML = groups.map((g, i) => {
      const kids = visible(g);
      const body = kids.map(k => { const sub = visible(k); return link(k) + (sub.length ? '<div class="sb-sub">' + sub.map(s => link(s, true)).join('') + '</div>' : ''); }).join('');
      return '<div class="sb-m-group"><button class="sb-m-head" type="button" aria-expanded="false" aria-controls="sb-m-body-' + i + '"><span class="sb-ring">' + (g.image ? '<img src="' + esc(thumb(g.image)) + '" alt="" loading="lazy">' : '') + '</span><span class="sb-m-name"><b>' + esc(g.label) + '</b><small>' + kids.length + ' ' + (kids.length === 1 ? 'category' : 'categories') + '</small></span><svg class="sb-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button><div class="sb-m-body" id="sb-m-body-' + i + '" hidden><a class="sb-m-all" href="' + esc(loc(firstHref(g))) + '">See all ' + esc(g.label) + ' →</a>' + body + '</div></div>';
    }).join('');
    box.addEventListener('click', e => {
      const head = e.target.closest('.sb-m-head');
      if (!head) return;
      const open = head.getAttribute('aria-expanded') !== 'true';
      box.querySelectorAll('.sb-m-head').forEach(h => { h.setAttribute('aria-expanded', 'false'); h.nextElementSibling.hidden = true; });
      if (open) { head.setAttribute('aria-expanded', 'true'); head.nextElementSibling.hidden = false; }
    });
    const quick = hub.querySelector('.mobile-quick');
    quick.parentNode.insertBefore(box, quick);
    hub.classList.add('sb-done');
  }

  let menuPromise = null;
  function load() {
    if (menuPromise) return menuPromise;
    const get = src => fetch(src, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    menuPromise = (async () => {
      let r = await get(root.dataset.menuSrc);
      if (!r.ok && root.dataset.menuFallback) r = await get(root.dataset.menuFallback);
      if (!r.ok) throw new Error('menu ' + r.status);
      return r.json();
    })();
    menuPromise.catch(() => { menuPromise = null; });
    return menuPromise;
  }

  function apply() {
    characters();
    root.querySelectorAll('.desktop [data-panel="shop"], [data-panel="shop"]').forEach(shop => {
      if (!shop.querySelector('.taxonomy-tabs') || shop.querySelector('.sb-shop-cols')) return;
      load().then(menu => columns(menu, shop)).catch(() => {});
    });
    root.querySelectorAll('.mobile-menu-v4 .mobile-hub').forEach(hub => {
      if (!hub.querySelector('.mobile-quick .mobile-circle-row') || hub.querySelector('.sb-m-groups')) return;
      if (!hub.querySelector('a[href*="/collections/"]')) return;
      load().then(menu => phoneGroups(menu, hub)).catch(() => {});
    });
  }

  apply();
  new MutationObserver(() => apply()).observe(root, { childList: true, subtree: true });
})();

/* Blogs: categories in the side menu open on click; on load only the first one is open (style book 2026-10-22). */
(() => {
  const tidy = () => document.querySelectorAll('.bc-categories-list').forEach(list => {
    if (list.dataset.sbTidy) return;
    const groups = [...list.querySelectorAll('.bc-category-group')];
    if (!groups.length) return;
    list.dataset.sbTidy = '1';
    groups.forEach((g, i) => g.classList.toggle('open', i === 0));
  });
  tidy();
  new MutationObserver(tidy).observe(document.documentElement, { childList: true, subtree: true });
})();

/* "Browse Embroidery Designs": the squares light up once when the button comes into view (approved 2026-10-22). */
(() => {
  const btn = document.querySelector('.artapli-designs-btn');
  if (!btn || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    io.disconnect(); btn.classList.add('sb-wave'); setTimeout(() => btn.classList.remove('sb-wave'), 1500);
  }), { threshold: .5 });
  io.observe(btn);
})();

/* "Recently viewed": arrows left and right instead of the scrollbar; swipe still works (Anna 2026-10-23). */
(() => {
  const icon = pts => `<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="${pts}"/></svg>`;
  const wire = grid => {
    if (grid.closest('.sb-shelf') || !grid.children.length) return;
    const shelf = document.createElement('div');
    shelf.className = 'sb-shelf';
    grid.parentNode.insertBefore(shelf, grid);
    shelf.appendChild(grid);
    const make = (dir, label, pts) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = `sb-shelf__btn sb-shelf__btn--${dir}`; b.setAttribute('aria-label', label);
      b.innerHTML = icon(pts);
      b.addEventListener('click', () => {
        const step = Math.max(grid.clientWidth * .85, 200);
        grid.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
      });
      shelf.appendChild(b);
      return b;
    };
    const prev = make('prev', 'Previous products', '15 6 9 12 15 18');
    const next = make('next', 'More products', '9 6 15 12 9 18');
    const update = () => {
      const max = grid.scrollWidth - grid.clientWidth;
      shelf.classList.toggle('sb-shelf--static', max < 4);
      prev.hidden = grid.scrollLeft < 4;
      next.hidden = grid.scrollLeft > max - 4;
      // centre the arrows on the pictures, not on the whole card
      const media = grid.querySelector('.card__media, .card__inner');
      if (media) {
        const top = media.getBoundingClientRect().top - shelf.getBoundingClientRect().top + media.offsetHeight / 2;
        prev.style.top = next.style.top = `${Math.round(top)}px`;
      }
    };
    grid.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(grid);
    new MutationObserver(update).observe(grid, { childList: true });
    addEventListener('load', update);
    update();
  };
  const scan = () => document.querySelectorAll('[class*="rv-grid-"]').forEach(wire);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
